import * as React from 'react';
import RD from 'react-datepicker';

/**
 * react-datepicker 类组件与 React 18 @types/react 的 JSX 校验不兼容（TS2786）。
 * 使用 ComponentType<any> 避免对 popper modifiers 等与运行时一致的宽松写法产生额外 TS2322。
 */
const ReactDatePicker = RD as unknown as React.ComponentType<Record<string, unknown>>;
export default ReactDatePicker;
